import Icon from "@mui/icons-material/ChatBubbleOutlined";

export default function ChatIcon() {
	return <Icon fontSize="small" />;
}